import { Component, OnInit } from '@angular/core';
import { StepTemplateBaseComponent } from 'app/core/components/dynamic-onboarding/step-template-base/step-template-base.component';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';

@Component({
  selector: 'itpx-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.css']
})
export class InstructionsComponent extends StepTemplateBaseComponent {

  constructor() { 
    super(); 
  }

  ngOnInit() {
    this.status.emit(ChildState.enabled);
    this.next.bindToLifecycle(this).filter(value => this.id === value).subscribe(_ => this.status.emit(ChildState.done));
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/instructions/instructions.component.ts